module.exports = "/_next/static/images/ospGlobe-c629d2615ee0f3411ece1845b4299f39.png.webp";